import axios from '@/utils/axios'


export function getLevelOne() {
    return axios({
      url: '/classify/getLevelOne',
      method: 'get'
    })
  }

  export function getLevelTwo(id) {
    return axios({
      url: '/classify/getLevelTwo',
      method: 'get',
      params: { id},
    })
  }

  export function getLevelAll(type) {
    return axios({
      url: '/classify/getLevelAll',
      method: 'get',
      params: { type},
    })
  }

  export function getLevelId(seqId) {
    return axios({
      url: '/classify/getLevelId',
      method: 'get',
      params: { seqId},
    })
  }